import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as selectors from "../../../application.selectors";

const Slider = styled.div`
  position:absolute;
  width:100%;
  height:5px;
  overflow-x: hidden;
  
  & .line{
    position:absolute;
    opacity: 0.4;
    background:#f99622;
    width:150%;
    height:5px;
  }
  
  & .subline{
    position:absolute;
    background:#f99622;
    height:5px; 
  }
  & .inc{
  animation: increase 2s infinite;
  }
  & .dec{
  animation: decrease 2s 0.5s infinite;
  }
  
  @keyframes increase {
   from { left: -5%; width: 5%; }
   to { left: 130%; width: 100%;}
  }
  @keyframes decrease {
   from { left: -80%; width: 80%; }
   to { left: 110%; width: 10%;}
  }
`;

const Border = styled.div`
  border-top: 5px solid #6CA9E5;
`;

const ProgressBar = ({busy}) => busy ? (
  <Slider>
    <div className="line"/>
    <div className="subline inc"/>
    <div className="subline dec"/>
  </Slider>) : <Border />;


export default connect(
  state => ({
    busy: selectors.fetchingData(state),
  })
)(ProgressBar);





// WEBPACK FOOTER //
// ./src/modules/layout/components/ProgressBar.js